import { all } from 'redux-saga/effects';

import authentication from './authenticationSagas';

export default function* rootSaga() {
  yield all([authentication()]);
}
